module.exports = "/images/blister-11.png";